
import { Vue, Options, Prop } from "vue-property-decorator";
@Options({
  name: "ui-loading",
})
export default class UiLoading extends Vue {
  @Prop({ default: "loading", type: String }) alternativeText!: string;
}
